import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/account-details/general/@client/page.tsx")